<template>
  <div class="cart-container">
    <div style="padding: 1.5rem 1.5rem 1rem 1.5rem">
      <div class="cart-header">
        <p class="cart-title">Košarica</p>
        <main-button
          v-if="showEdit"
          outline
          class="edit-button"
          color="dinamoBlue"
          @click="$emit('edit')"
        >
          Uredi
          <v-icon style="margin-left: 8px; color: #0054a5">edit </v-icon>
        </main-button>
      </div>
      <table class="wp-table">
        <tr>
          <th>{{ $t('subscriptionType') }}</th>
          <th>{{ $t('ticketQuantity') }}</th>
          <th style="text-align: right">{{ $t('price') }}</th>
        </tr>
        <tr v-for="data in modifyOrderData()" :key="data.id">
          <td>{{ data.name }}</td>
          <td>{{ data.count }}</td>
          <td style="text-align: right">{{ data.price }} {{ data.currency }}</td>
        </tr>
      </table>
    </div>
    <div class="sum-container">
      <div style="display: flex; justify-content: space-between">
        <p class="total">UKUPNO</p>
        <p class="total-price">{{ getTotalPrice().toFixed(2) }} EUR</p>
      </div>
      <main-button v-if="showNext" style="margin-top: 2rem" color="#0054A5" @click="handleNext">
        Nastavi s kupnjom
        <v-icon style="color: white">chevron_right</v-icon>
      </main-button>
    </div>
  </div>
</template>

<script>
import { exchangeRate } from '@/utils'

export default {
  name: 'sport-organization-shopping-cart',
  components: {},
  props: {
    order: {
      type: Array,
      default: () => [],
    },
    showNext: {
      type: Boolean,
      default: true,
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({ user: null, exchangeRate }),
  methods: {
    modifyOrderData() {
      const updatedData = []
      this.order.map(item => {
        const existingItem = updatedData.find(data => data.id === item.id)
        existingItem ? (existingItem.count += 1) : updatedData.push({ ...item, count: 1 })
      })

      return updatedData
    },
    getTotalPrice() {
      return this.order.reduce((acc, curr) => (acc += Number(curr.price)), 0)
    },
    handleNext() {
      return this.$emit('next', `EUR ${this.getTotalPrice().toFixed(2)}`)
    },
  },
}
</script>

<style scoped>
.cart-container {
  border-radius: 0.25rem;
  border: 1px solid #0054a5;
}
.cart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.edit-button {
  border-radius: 0;
}
.wp-table {
  width: 100%;
  margin-top: 1rem;
  border-collapse: collapse;
  table-layout: fixed;
}
.wp-table tr {
  border-bottom: 1px solid rgba(151, 151, 151, 0.5);
}
.wp-table th:first-child,
.wp-table td:first-child {
  word-break: keep-all;
}

.wp-table th:nth-child(2),
.wp-table td:nth-child(2) {
  padding-right: 2rem;
  text-align: right;
  @media screen and (max-width: 800px) {
    padding-right: 1rem;
  }
  @media screen and (max-width: 400px) {
    padding-right: 2rem;
  }
  margin: auto;
}

.wp-table tr:last-child {
  border-bottom: none;
}

.wp-table td,
.wp-table th {
  padding: 6px 6px;
  display: table-cell;
  text-align: left;
  vertical-align: top;
  color: #333333;
}
th {
  color: #0054a5 !important;
  font-family: 'Source Sans Pro';
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 0.9rem */
  text-transform: uppercase;
}
td {
  color: #333;
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 1.5rem */
}
.cart-title {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
}
.sum-container {
  border-top: 1px solid #0054a5;
  padding: 1rem 1.5rem 1.5rem 1.5rem;
  display: flex;
  flex-direction: column;
  background: rgba(0, 130, 255, 0.1);
}
.total-price {
  color: #333;
  text-align: right;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 1.5rem */
  letter-spacing: -0.0375rem;
  text-transform: uppercase;
}
.total {
  color: #333;
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 1.5rem */
}
p {
  margin: 0;
}
</style>
